module.exports = __webpack_public_path__ + "media/images/banners/session-annual3000-c1152003cf654847a7645e355eb344ee.png";